import { takeEvery, put, call } from "redux-saga/effects";

import {
  sendNotificationAPI,
  sendNotificationV2API,
} from "../../helpers/backend.helper";
import { SEND_NOTIFICATION, SEND_NOTIFICATION_V2 } from "./actionTypes";
import {
  sendNotificationSuccess,
  sendNotificationError,
  sendNotificationV2Success,
  sendNotificationV2Error,
} from "./actions";

function* sendNotification({ payload: { request } }) {
  try {
    const response = yield call(sendNotificationAPI, request);
    if (response) {
      yield put(sendNotificationSuccess(response?.data));
    }
  } catch (error) {
    yield put(sendNotificationError(error));
  }
}

function* sendNotificationV2({ payload: { request } }) {
  try {
    const response = yield call(sendNotificationV2API, request);
    if (response) {
      yield put(sendNotificationV2Success(response?.data));
    }
  } catch (error) {
    yield put(sendNotificationV2Error(error));
  }
}

function* notificationsSaga() {
  yield takeEvery(SEND_NOTIFICATION, sendNotification);
  yield takeEvery(SEND_NOTIFICATION_V2, sendNotificationV2);
}

export default notificationsSaga;
